mutation InvoiceSigningDraftRelease($input: InvoiceSigningDraftReleaseInput!) {
  invoiceSigningDraftRelease(input: $input) {
    clientMutationId
    releaseRequestResults {
      id
      rowTimestamp
    }
  }
}
